<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="dictName" :label="moduleName+'名称：'">
        <el-input v-model="dataForm.dictName" size="mini" clearable type="text"
                  :placeholder="moduleName+'名称：'"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="addOrUpdateHandle">添加</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/sys/dict/list" delete-url="/sys/dict" :query-form="dataForm" :auto-load="false" :is-page="false">
      <el-table-column
          prop="dictName"
          :label="$t('dict.dictName')"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="remark"
          :label="$t('dict.remark')"
          header-align="center"
          align="center"
      ></el-table-column>

      <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
      >
        <template slot-scope="scope">
          <el-button
              v-if="$hasPermission('sys:dict:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row)"
          >{{ $t('update') }}
          </el-button
          >
          <el-button
              v-if="$hasPermission('sys:dict:delete')"
              type="text"
              size="small"
              @click="doDelete(scope.row,'dictName')"
          >{{ $t('delete') }}
          </el-button
          >
        </template>
      </el-table-column>
      <add-or-update
          :module-name="moduleName"
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
          @refreshDataList="getDataList"
          :pid="pid"
          :dict-type="dictType"
      ></add-or-update>
    </SweetTable>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  components: { AddOrUpdate },
  props: {
    pid: {
      type: String,
      default: ''
    },
    moduleName: '',
    dictType: ''
  },
  data () {
    return {
      dataForm: {
        pid: '0',
        dictName: '',
        dictType: '',
        dictValue: '',
      },
    }
  },
  watch: {
    pid: {
      handler: function () {
        this.dataForm.pid = this.pid
        this.reload()
      },
      immediate: true
    },
  },
  methods: {
    addOrUpdateHandle (row = {}) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.id = row.id
        this.$refs.addOrUpdate.dataForm.pid = this.pid
        this.$refs.addOrUpdate.init()
      })
    },
  },
}
</script>
